import { rem } from 'polished';
import styled from 'styled-components';

export const Wrapper = styled.aside`
  width: fit-content;
  background: ${({ theme }) => theme.colors.background.secondary};
  padding: ${rem(13)} ${rem(12)};
  font-size: ${rem(14)};
  font-weight: 600;
  border-radius: ${rem(12)};
  display: flex;
  flex-flow: row;

  svg {
    margin-left: ${rem(4)};
  }

  div[data-placement] {
    z-index: 100;
  }

  #allowance-tooltip {
    font-weight: 400;
  }

  small {
    margin-left: ${rem(8)};
    font-size: ${rem(14)};
    color: ${({ theme }) => theme.colors.text.secondary};
    font-weight: 400;

    &::before {
      content: '|';
      margin-right: ${rem(8)};
      color: ${({ theme }) => theme.colors.border.secondary};
    }
  }
`;
